/**
 * Button to open small form to mannually enter
 * number of due reminders sent to the Client.
 *
 * Click on the button opens Overlay with the dialog.
 * Upon confirm, `callback` prop function gets called.
 *
 * Props:
 *   callback {function}
 *   bsSize,  // one of: "lg", "large", "sm", "small", "xs", "xsmall"
 *   bsStyle, // one of "primary", "success", "info", "warning", "danger", "link"
 *
 * Slots:
 *   default – content of the main button
 *
 */

import React from 'react';
import { Button, Overlay, Popover, FormGroup, FormControl, InputGroup } from 'react-bootstrap';

export default class InvoiceRemindersForm extends React.Component {
  constructor(props) {
    super(props);

    const { value: initialValue } = props;

    this.state = {
      isOverlayVisible: false,
      value: initialValue || '',
    };

    this.buttonRef = React.createRef();
  }

  handleClick = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState(prevState => ({ isOverlayVisible: !prevState.isOverlayVisible }));
  };

  handleChange = event => {
    const { value } = event.target;
    const newValue = value.replace(/,/g, '.');

    this.setState({ value: newValue });
  };

  doClose = e => {
    e.preventDefault();
    e.stopPropagation();

    this.setState({ isOverlayVisible: false });
  };

  onConfirm = e => {
    const { callback } = this.props;
    const { value } = this.state;

    e.preventDefault();
    e.stopPropagation();

    this.setState({ isOverlayVisible: false });
    callback(value); // function to call once confirmed
  };

  stopPropagation = e => e.stopPropagation();

  render() {
    const {
      text,
      bsSize, // one of: "lg", "large", "sm", "small", "xs", "xsmall"
      bsStyle, // one of "primary", "success", "info", "warning", "danger", "link"
      container,
      placement,
      children,
    } = this.props;

    const { isOverlayVisible, value } = this.state;

    return (
      <React.Fragment>
        <Button
          ref={this.buttonRef}
          bsSize={bsSize}
          bsStyle={bsStyle}
          className="btn-rounded"
          onClick={this.handleClick}
        >
          {children}
        </Button>

        <Overlay
          show={isOverlayVisible}
          target={this.buttonRef.current}
          placement={placement}
          rootClose
          onHide={() => {
            this.setState({ isOverlayVisible: false });
          }}
          onClick={event => event.stopPropagation()}
          container={container !== undefined ? container : undefined}
        >
          <Popover style={{ zIndex: 1200 }} title={text.title}>
            <div>{text.confirm}</div>

            <div style={{ width: '140px' }}>
              <FormGroup>
                <InputGroup>
                  <FormControl
                    type="number"
                    placeholder={text.placeholder}
                    value={value}
                    onClick={this.stopPropagation}
                    onChange={this.handleChange}
                  />
                </InputGroup>
              </FormGroup>
              <Button block bsSize="sm" className="m-t-1" bsStyle="primary" onClick={this.onConfirm}>
                {text.button}
              </Button>
            </div>
          </Popover>
        </Overlay>
      </React.Fragment>
    );
  }
}

InvoiceRemindersForm.defaultProps = {
  callback: value => console.log('InvoiceRemindersForm confirmed', value),
  placement: 'top',
  text: {
    title: 'Reminders sent',
    confirm: 'Are u sure?',
    placeholder: 'Number of reminders',
    button: 'OK',
  },
  bsSize: 'sm', // Bootstrap button size
  bsStyle: 'info', // Bootstrap contextual class for the button
};
